import { render, staticRenderFns } from "./EntityDetail.vue?vue&type=template&id=5042ee5a&"
import script from "./EntityDetail.vue?vue&type=script&lang=js&"
export * from "./EntityDetail.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetail.vue?vue&type=style&index=0&id=5042ee5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports